import {NgModule} from '@angular/core';
import {LoginRoutingModule} from './login-routing.module';
import {SharedModule} from '../shared/shared.module';
import {LoginLayoutComponent} from '@app/login/views/login-layout/login-layout.component';
import {LOGIN_MODULE_CONFIG, LOGIN_MODULE_CONSTANTS} from '@app/login/login.module.config';

@NgModule({
  imports: [
    SharedModule,
    LoginRoutingModule
  ],
  declarations: [LoginLayoutComponent],
  providers: [
    {provide: LOGIN_MODULE_CONFIG, useValue: LOGIN_MODULE_CONSTANTS}
  ]
})
export class LoginModule {
}
